import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import ReactPaginate from "react-paginate";

export default function CancelRequests() {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

    const [challenge, setchallenge] = useState([])
    let [limit, setLimit] = useState(10);
    const [pageNumber, setPageNumber] = useState(1); 
    const [numberOfPages, setNumberOfPages] = useState(0);

    const setpageLimit = (event) => {
        setLimit(event.target.value);
        setPageNumber(1);
    }

    const handlePageClick = (data) => {
        setPageNumber(data.selected + 1);
    };

    const Allchallenge = async () => {
        const access_token = localStorage.getItem('token')
        const headers = { Authorization: `Bearer ${access_token}` }
        axios.get(`${baseUrl}challange/cancel_requests?page=${pageNumber}&_limit=${limit}`, { headers })
            .then((res) => {
                setchallenge(res.data.status)
                setNumberOfPages(res.data.totalPages)
            })
            .catch(err => console.log(err))
    }

    const dateFormat = (e) => {
        if (!e) return "---";
        const date = new Date(e);
        return date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
    }

    useEffect(() => {
        Allchallenge()
        const interval = setInterval(Allchallenge, 5000); // Auto refresh every 5 seconds
        return () => clearInterval(interval);
    }, [pageNumber, limit])

    if (challenge === undefined) {
        return null
    }

    return (
        <div className="cancelled-challenges-container p-2 p-md-4">
            <style>{`
                .cancelled-challenges-container { background: #f0f2f5; min-height: 100vh; font-family: 'Poppins', sans-serif; }
                .header-card { background: #fff; padding: 20px; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); margin-bottom: 25px; display: flex; flex-direction: column; gap: 15px; }
                
                @media (min-width: 768px) {
                    .header-card { flex-direction: row; justify-content: space-between; align-items: center; padding: 25px; }
                }

                .table-card-main { background: #ffffff; border-radius: 25px; overflow: hidden; box-shadow: 0 15px 35px rgba(0,0,0,0.1); border: none; }
                .table-banner-header { background: linear-gradient(45deg, #e67e22, #d35400); color: #ffffff !important; padding: 18px 25px; font-weight: 700; font-size: 1.1rem; }
                
                .table-responsive-wrapper { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; background: #fff; }
                .custom-table-cancelled { width: 100%; border-collapse: collapse; min-width: 1000px; table-layout: auto; }
                
                .custom-table-cancelled th { background: #f8f9fa; color: #334155 !important; padding: 15px 12px; font-weight: 800; text-transform: uppercase; font-size: 0.75rem; border-bottom: 2px solid #edf2f7; text-align: center; white-space: nowrap; }
                .custom-table-cancelled td { padding: 15px 12px; vertical-align: middle; border-bottom: 1px solid #f1f1f1; font-size: 0.85rem; color: #000 !important; text-align: center; font-weight: 600; white-space: nowrap; }
                .custom-table-cancelled tbody tr:hover { background-color: #fef5e7; }

                .status-badge-request { background: #fff3e0; color: #e67e22 !important; padding: 6px 12px; border-radius: 10px; font-weight: 700; font-size: 0.7rem; text-transform: uppercase; border: 1px solid #ffe0b2; }
                .btn-view-action { background: #e67e22; color: white !important; border-radius: 8px; font-weight: 700; font-size: 0.8rem; padding: 8px 16px; border: none; transition: 0.3s; text-decoration: none; display: inline-block; }
                .btn-view-action:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(230, 126, 34, 0.3); background: #d35400 !important; }

                .pagination-wrapper .page-link { border-radius: 10px !important; margin: 0 4px; background: #fff; color: #d35400; font-weight: 600; border: none; box-shadow: 0 2px 5px rgba(0,0,0,0.05); padding: 8px 16px; }
                .pagination-wrapper .page-item.active .page-link { background: #e67e22 !important; color: #fff !important; }
            `}</style>

            <div className="header-card">
                <div>
                    <h3 className="m-0" style={{fontWeight: 900, color: '#1e293b'}}>Cancel <span style={{color: '#e67e22'}}>Requests</span></h3>
                    <p className="text-muted m-0" style={{fontSize: '0.85rem'}}>Review games where players have requested termination</p>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <label className="m-0 mr-2 font-weight-bold" style={{fontSize: '0.85rem'}}>Rows:</label>
                    <select className='form-control form-control-sm' style={{width: '90px', borderRadius: '8px', border: '2px solid #edf2f7', fontWeight: 'bold'}} onChange={setpageLimit} value={limit}>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                    </select>
                </div>
            </div>

            <div className="table-card-main">
                <div className="table-banner-header">⚠️ Active Termination Requests</div>
                <div className="table-responsive-wrapper">
                    <table className="custom-table-cancelled">
                        <thead>
                            <tr>
                                <th style={{width: '60px'}}>#</th>
                                <th>Challenge ID</th>
                                <th>Creator</th>
                                <th>Accepter</th>
                                <th>Amount</th>
                                <th>Current Status</th>
                                <th>Req By</th>
                                <th>Time</th>
                                <th style={{width: '120px'}}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {challenge && challenge.length > 0 ? challenge.map((game, key) => (
                                <tr key={key}>
                                    <td style={{color: '#64748b'}}>#{(pageNumber - 1) * limit + (key + 1)}</td>
                                    <td style={{fontFamily: 'monospace', color: '#1e293b !important'}}>{game._id}</td>
                                    <td style={{fontWeight: 700}}>{game.Created_by?.Name || '---'}</td>
                                    <td style={{fontWeight: 700}}>{game.Accepetd_By?.Name || '---'}</td>
                                    <td style={{color: '#27ae60 !important', fontWeight: '800'}}>₹{game.Game_Ammount}</td>
                                    <td><span className="status-badge-request">{game.Status}</span></td>
                                    <td>
                                        {(game.Creator_Status === 'cancel' || game.Creator_Status === 'cancelled') && <span className="badge badge-danger mr-1">Creator</span>}
                                        {(game.Acceptor_status === 'cancel' || game.Acceptor_status === 'cancelled') && <span className="badge badge-danger">Joiner</span>}
                                    </td>
                                    <td style={{fontSize: '0.75rem', color: '#64748b'}}>{dateFormat(game.updatedAt)}</td>
                                    <td>
                                        <Link className="btn-view-action" to={`/view/${game._id}`}>
                                            Review & Resolve
                                        </Link>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-5" style={{color: '#94a3b8'}}>No active cancel requests.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className='pagination-wrapper mt-4'>
                <ReactPaginate
                    previousLabel={"←"}
                    nextLabel={"→"}
                    breakLabel={"..."}
                    pageCount={numberOfPages}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center flex-wrap"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link shadow-sm"}
                    activeClassName={"active"}
                    forcePage={pageNumber - 1}
                />
            </div>
        </div>
    )
}
